<h4 i18n="Order from history: order date filter@@order.from.history.date.filter"
>Order date</h4>

<ul class="filter-checkbox-list">
    <li class="filter-checkbox-list-item">
        <label class="filter-checkbox-list_label">
            <input
                (click)="setLastTwoWeeks()"
                [checked]="lastTwoWeeksChecked"
                name="predefinedRange"
                type="radio"
            />
            <span class="checkbox-icon"></span>
            <span
                class="filter-checkbox-list-item_name"
                i18n="Order from history: last two weeks@@order.history.lasttwoweeks"
            >
        Last two weeks
      </span>
        </label>
    </li>
    <li class="filter-checkbox-list-item">
        <label class="filter-checkbox-list_label">
            <input
                (click)="setLastMonth()"
                [checked]="lastMonthChecked"
                name="predefinedRange"
                type="radio"
            />
            <span class="checkbox-icon"></span>
            <span
                class="filter-checkbox-list-item_name"
                i18n="Order from history: last month@@order.history.lastmonth"
            >
        Last month
      </span>
        </label>
    </li>
    <li class="filter-checkbox-list-item">
        <label class="filter-checkbox-list_label">
            <input
                (click)="setSamePeriodLastYear()"
                [checked]="samePeriodLastYearChecked"
                name="predefinedRange"
                type="radio"
            />
            <span class="checkbox-icon"></span>
            <span
                class="filter-checkbox-list-item_name"
                i18n="Order from history: same period last year@@order.history.periodlastyear"
            >
        Same period last year
      </span>
        </label>
    </li>
</ul>
<br />

<h4 i18n="Order from history: pick a date@@order.history.date.picker">
    Pick a date
</h4>
<label i18n="Order from history 'From' label@@filter.from">From</label>
<material-datepicker
    (select)="setDateFrom($event)"
    [(date)]="dateFrom"
    [(rangeEnd)]="dateTo"
    [inputText]="getInputText(dateFrom)"
    data-cy-datepicker="from"
></material-datepicker>

<label i18n="Order from history 'Until' label@@filter.until">Until</label>
<material-datepicker
    (select)="setDateTo($event)"
    [(date)]="dateTo"
    [(rangeEnd)]="today"
    [(rangeStart)]="dateFrom"
    [inputText]="getInputText(dateTo)"
    data-cy-datepicker="to"
></material-datepicker>
